<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'

const route = useRoute()

const handleNextStep = async () => {
  await handleNext('tutorial_resources_refineries')
}

const isOnResourcesSection = computed(() => {
  return route.path.startsWith('/resources')
})
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/resources.webm"
  >
    <template #text>
      <p class="pb-2">
        Eventually you will want to get more refined ores/materials. These can be obtained by building refineries.
      </p>
      <p class="pb-2">
        Refineries are build on planets like any building, and can be found under the <GenericIcon type="refinery"/> group in the planet building queue.
      </p>
      <p class="pb-2">
        Keep in mind that refineries cost credits when they operate, so don't build to many of them.
      </p>
    </template>

    <template #alerts>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">
        Understood
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>